"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSearch = void 0;
const BaseSearch_1 = require("./BaseSearch");
class TextSearch extends BaseSearch_1.BaseSearch {
    isValid() {
        if (this._params.has('location') && !this._params.has('radius')) {
            throw new Error('radius is required when location is provided');
        }
        return true;
    }
}
exports.TextSearch = TextSearch;
//# sourceMappingURL=TextSearch.js.map